
import { Label } from "@/components/ui/label";
import { Slider } from "@/components/ui/slider";

interface SalaryRangeFilterProps {
  salaryRange: [number, number];
  onSalaryRangeChange: (value: [number, number]) => void;
}

export function SalaryRangeFilter({
  salaryRange,
  onSalaryRangeChange,
}: SalaryRangeFilterProps) {
  const handleMinSalaryChange = (value: number[]) => {
    onSalaryRangeChange([value[0], salaryRange[1]]);
  };

  return (
    <div className="space-y-2">
      <Label className="text-foreground">Minimum Monthly Salary</Label>
      <Slider
        min={0}
        max={200000}
        step={10000}
        value={[salaryRange[0]]}
        onValueChange={handleMinSalaryChange}
        className="my-4"
      />
      <div className="flex justify-between text-sm text-muted-foreground">
        <span>₹{salaryRange[0].toLocaleString()}</span>
        <span>₹200,000+</span>
      </div>
    </div>
  );
}
